import React, { useState } from "react";
import { Transformacao, TransformadorRegra, REGRAS_DESCRICAO } from "../../../../../domain/models/city-adapter-config";
import * as S from "../styles";

type Props = {
  transformacoes: Transformacao[];
  onChange: (transformacoes: Transformacao[]) => void;
};

const REGRAS: TransformadorRegra[] = [
  "FORMATAR_LC116_COM_PONTO",
  "REMOVER_PONTO_LC116",
  "APENAS_NUMEROS_PAD_7",
  "REMOVER_ACENTOS_E_ESPECIAIS",
  "CONVERTER_PARA_FLOAT",
];

const TransformacoesSection: React.FC<Props> = ({ transformacoes, onChange }) => {
  const [novoCaminho, setNovoCaminho] = useState("");
  const [novaRegra, setNovaRegra] = useState<TransformadorRegra>("FORMATAR_LC116_COM_PONTO");
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editCaminho, setEditCaminho] = useState("");
  const [editRegra, setEditRegra] = useState<TransformadorRegra>("FORMATAR_LC116_COM_PONTO");

  const handleAdd = (): void => {
    if (!novoCaminho.trim()) return;
    onChange([...transformacoes, { caminho: novoCaminho.trim(), regra: novaRegra }]);
    setNovoCaminho("");
  };

  const handleRemove = (index: number): void => {
    onChange(transformacoes.filter((_, i) => i !== index));
    if (editIndex === index) setEditIndex(null);
  };

  const handleStartEdit = (index: number): void => {
    const t = transformacoes[index];
    setEditIndex(index);
    setEditCaminho(t.caminho);
    setEditRegra(t.regra);
  };

  const handleSaveEdit = (): void => {
    if (editIndex === null || !editCaminho.trim()) return;
    const updated = [...transformacoes];
    updated[editIndex] = { caminho: editCaminho.trim(), regra: editRegra };
    onChange(updated);
    setEditIndex(null);
  };

  const handleCancelEdit = (): void => {
    setEditIndex(null);
  };

  return (
    <S.SectionCard>
      <S.SectionTitle>Transformações</S.SectionTitle>
      <S.InfoBox>
        ℹ️ Aplica formatação no valor de um campo existente. Ex: formatar código LC 116 de
        &quot;0107&quot; para &quot;01.07&quot;.
      </S.InfoBox>

      {transformacoes.length > 0 && (
        <S.Table>
          <thead>
            <tr>
              <th>Caminho</th>
              <th>Regra</th>
              <th aria-label="Ações" />
            </tr>
          </thead>
          <tbody>
            {transformacoes.map((t, i) => (
              editIndex === i ? (
                <tr key={`t-edit-${i}`}>
                  <td><S.FormInput value={editCaminho} onChange={(e) => setEditCaminho(e.target.value)} style={{ minWidth: 100 }} /></td>
                  <td>
                    <S.FormSelect value={editRegra} onChange={(e) => setEditRegra(e.target.value as TransformadorRegra)}>
                      {REGRAS.map((regra) => (
                        <option key={regra} value={regra}>{REGRAS_DESCRICAO[regra]}</option>
                      ))}
                    </S.FormSelect>
                  </td>
                  <td>
                    <S.IconButton type="button" onClick={handleSaveEdit}>✅</S.IconButton>
                    <S.IconButton type="button" onClick={handleCancelEdit}>❌</S.IconButton>
                  </td>
                </tr>
              ) : (
                <tr key={`t-${t.caminho}-${i}`}>
                  <td><code>{t.caminho}</code></td>
                  <td>{REGRAS_DESCRICAO[t.regra]}</td>
                  <td>
                    <S.IconButton type="button" onClick={() => handleStartEdit(i)}>✏️</S.IconButton>
                    <S.IconButton type="button" onClick={() => handleRemove(i)}>🗑️</S.IconButton>
                  </td>
                </tr>
              )
            ))}
          </tbody>
        </S.Table>
      )}

      <S.FormRow>
        <S.FormInput
          placeholder="Caminho (ex: servico[].codigo)"
          value={novoCaminho}
          onChange={(e) => setNovoCaminho(e.target.value)}
        />
        <S.FormSelect value={novaRegra} onChange={(e) => setNovaRegra(e.target.value as TransformadorRegra)}>
          {REGRAS.map((regra) => (
            <option key={regra} value={regra}>
              {REGRAS_DESCRICAO[regra]}
            </option>
          ))}
        </S.FormSelect>
        <S.SmallButton type="button" onClick={handleAdd}>+ Adicionar</S.SmallButton>
      </S.FormRow>
    </S.SectionCard>
  );
};

export default TransformacoesSection;
